export const manifest = {
  screens: {
    scr_hrsyuo: { name: "Home", route: "/" },
  },
}
